module.exports = __webpack_public_path__ + "static/media/mailSmallIcon.eb62e780.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/MessageBar/mailSmallIcon.svg
// module id = 1814
// module chunks = 0